import React from 'react'
import Header from '../../components/shared/Header'
import Footer from '../../components/shared/Footer'
import PressHero from '../../components/PressAndNews/PressHero'
import AdvertisementsSection from '../../components/PressAndNews/AdvertisementsSection'
import SustainabilityPartnershipBanner from '../../components/PressAndNews/SustainabilityPartnershipBanner'
import ArticlesAndEventsGrid from '../../components/PressAndNews/ArticlesAndEventsGrid'

function PressAndNews() {
  return (
    <>
    <Header/>
    <div className='ml-72 text-[48px] font-bold mt-20 '>
  <span className='text-[#0D924F]'>  Press & </span>News
    </div>
    <div className='ml-72 text-[18px] font-normal mb-20  text-[#898989]'>
        Explore the latest news, media coverage, and partner advertisements driving sustainability forward.
    </div>
    <PressHero/>
    <AdvertisementsSection/>
    <SustainabilityPartnershipBanner/>
    <ArticlesAndEventsGrid/>
    <Footer/>
    </>
  )
}

export default PressAndNews